import { Box, Link, Logo, Text } from '@betterment/samba-react';

interface NotFoundProps {
  backPath: string;
  backName: string;
}

export function NotFound({ backPath, backName }: NotFoundProps) {
  return (
    <Box css={{ height: '100vh', display: 'grid' }}>
      <Box css={{ paddingLeft: 'space.300', paddingTop: 'space.150' }}>
        <Logo type="b4aSignatureStacked" css={{ height: 'size.450' }} />
      </Box>
      <Box
        css={{
          display: 'flex',
          justifySelf: 'center',
          flexDirection: 'column',
          textAlign: 'center',
          maxWidth: 'breakpoint-md',
        }}
      >
        <Text as="div" variant="text400" css={{ marginBottom: 'space.400' }}>
          The page you requested could not be found.
        </Text>
        <Text css={{ marginBottom: 'space.100' }}>
          Please enter a valid address or return to <Link href={backPath}>{backName}</Link>
        </Text>
        <Text>
          As always, your money is safe and secure. If you have any questions, please contact our support team at{' '}
          <Link href="mailto:support@betterment.com">support@betterment.com</Link> or (646) 600-8263.
        </Text>
      </Box>
    </Box>
  );
}
